import type { StoryBlokComponentProps } from 'util/storyblok/types/component.types';
import type { SuperpowerSlideBlokData } from './superpower-slide/SuperpowerSlide.data';

export type ShapeType = ('moon' | 'pinwheel' | 'bonsai' | 'scale')[number];

export type SuperpowerConfig = {
  path?: string;
  foregroundColor: string;
  backgroundColor: string;
  shapeColor: string;
};

export const superpowerConfig: Record<ShapeType, SuperpowerConfig> = {
  moon: {
    path: 'path/to/model?',
    foregroundColor: '#000',
    backgroundColor: '#E8A9A8',
    shapeColor: '#f29a9a',
  },
  pinwheel: {
    path: 'path/to/model?',
    foregroundColor: '#000',
    backgroundColor: '#F8F0E4',
    shapeColor: '#fff4bb',
  },
  bonsai: {
    path: 'path/to/model?',
    foregroundColor: '#fff',
    backgroundColor: '#1F4037',
    shapeColor: '#39594d',
  },
  scale: {
    path: 'path/to/model?',
    foregroundColor: '#fff',
    backgroundColor: '#171717',
    shapeColor: '#312e2c',
  },
};

export type SuperpowersRef = HTMLElement;
export type SuperpowersBlokData = {
  title?: string;
  slides: Array<SuperpowerSlideBlokData>;
};
export type SuperpowersProps = {
  blok: SuperpowersBlokData;
} & StoryBlokComponentProps;
